<div class="profile-pic mx-auto">
    <img class="img" [src]="src()" alt="profile picture" fill/>
</div>
